import { render, staticRenderFns } from "./RecGameItem.vue?vue&type=template&id=055e69ac&scoped=true"
import script from "./RecGameItem.vue?vue&type=script&lang=js"
export * from "./RecGameItem.vue?vue&type=script&lang=js"
import style0 from "./RecGameItem.vue?vue&type=style&index=0&id=055e69ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055e69ac",
  null
  
)

export default component.exports